import useSWR from 'swr';
import { getRootApiUri } from '@landr/core';
import { SwrFetcher } from '../utils/swr.es.js';
import { useCurrentSubscriptions } from './useCurrentSubscriptionsHooks.es.js';
import { usePricingContext } from '../contexts/PricingProvider/PricingContext.es.js';
import { EventIds } from '../constants/EventIds.es.js';
import { ServiceOfferKind } from '../types/common.es.js';

var SamplesCatalogPath = '/subscription/api/v1/catalog/samples';
var useSamplesCatalog = function useSamplesCatalog() {
  var _usePricingContext = usePricingContext(),
    env = _usePricingContext.env,
    log = _usePricingContext.log,
    authorizationToken = _usePricingContext.authorizationToken;
  var _useSWR = useSWR([getRootApiUri(env, SamplesCatalogPath), authorizationToken], SwrFetcher, {
      revalidateOnFocus: false,
      onError: function onError(err) {
        log.warn('Unable to fetch samples catalog', EventIds.PricingPagePartialLoadDataFail, err);
      }
    }),
    data = _useSWR.data,
    error = _useSWR.error;
  var loading = !error && !data;
  return {
    data: data,
    loading: loading,
    error: error
  };
};

/**
 * @deprecated use `useCurrentSubscriptions` instead
 */
var useSamplesCurrentPlan = function useSamplesCurrentPlan() {
  var _useCurrentSubscripti = useCurrentSubscriptions(),
    data = _useCurrentSubscripti.data,
    loading = _useCurrentSubscripti.loading,
    error = _useCurrentSubscripti.error;
  var samplesSubscription = data === null || data === void 0 ? void 0 : data.find(function (subscription) {
    return subscription.serviceOffer === ServiceOfferKind.Samples;
  });

  // if undefined, it means the user has no plan
  return {
    data: samplesSubscription,
    loading: loading,
    error: error
  };
};

export { SamplesCatalogPath, useSamplesCatalog, useSamplesCurrentPlan };
